import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  SimpleChanges,
  OnChanges,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AllasContactInput } from '../../shared/ui/allas-contact-input/allas-contact-input';
import { ContactFormControl } from '../../../types/Contact.types';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'allas-contact-form',

  imports: [CommonModule, ReactiveFormsModule, AllasContactInput],
  template: `
    <section class="space-y-6">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        @for (field of formFields; track field.id) { @if (field.fullWidth) {
        <div class="md:col-span-2">
          <allas-contact-input
            [(value)]="field.value"
            (valueChange)="field.dirty = true"
            [label]="field.label"
            [id]="field.id"
            [placeholder]="field.placeholder"
            [dirty]="field.dirty || false"
            [type]="field.type || 'input'"
            [fullWidth]="field.fullWidth || false"
          ></allas-contact-input>
        </div>
        } @else {
        <allas-contact-input
          [(value)]="field.value"
          (valueChange)="field.dirty = true"
          [label]="field.label"
          [id]="field.id"
          [placeholder]="field.placeholder"
          [dirty]="field.dirty || false"
          [type]="field.type || 'input'"
          [fullWidth]="field.fullWidth || false"
        ></allas-contact-input>
        } }
      </div>

      <!-- Action Buttons -->
      <div
        class="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-4 fs-condensed"
      >
        <button
          type="button"
          (click)="onCancel()"
          class="px-16 py-4 border border-gray-300 rounded-md text-gray-700 font-medium hover:bg-gray-50 transition-colors"
        >
          CANCELAR
        </button>
        <button
          (click)="onSubmit()"
          [disabled]="!isValid() || isSubmitting"
          class="px-16 py-4 bg-black text-white rounded-md font-medium hover:bg-gray-900 transition-colors disabled:opacity-75 disabled:cursor-not-allowed"
        >
          <span *ngIf="!isSubmitting">ENVIAR</span>
          <span *ngIf="isSubmitting">Enviando...</span>
        </button>
      </div>
    </section>
  `,
})
export class ContactFormComponent {
  private notificationService = inject(NotificationService);
  @Input() form: ContactFormControl = {};
  @Input() category: string = '';
  @Input() dynamicField1?: {
    id: string;
    label: string;
    controlName: string;
    type?: string;
  };
  @Input() dynamicField2?: {
    id: string;
    label: string;
    controlName: string;
    type?: string;
  };
  @Input() dynamicField3?: {
    id: string;
    label: string;
    controlName: string;
    type?: string;
  };
  @Output() formSubmit = new EventEmitter<ContactFormControl>();
  @Output() formCancel = new EventEmitter<void>();

  isSubmitting = false;

  handleValueChange(field: any) {
    console.log(field);
  }

  constructor(private fb: FormBuilder) {}

  get formFields() {
    return Object.values(this.form);
  }

  isValid() {
    return Object.values(this.form).every((field) => field.value.trim() !== '');
  }

  onSubmit() {
    if (this.isSubmitting) {
      this.notificationService.showError(
        'Por favor, espere a que se complete el envío.'
      );
      return;
    }

    this.isSubmitting = true;

    if (!this.isValid()) {
      this.notificationService.showError(
        'Por favor, complete todos los campos requeridos.'
      );
      return;
    }

    this.notificationService.showSuccess('Enviando formulario...');

    this.formSubmit.emit(this.form);
  }

  onCancel() {
    this.formCancel.emit();
  }
}
